import * as THREE from 'three'
import { useRef, useState, useEffect } from 'react'
import { useFrame } from '@react-three/fiber'
import { Text } from '@react-three/drei'

const regular = import('@pmndrs/assets/fonts/inter_regular.woff')

export default function FlatTextClickable({ pageIndex = 0, clickCallback, children, ...props }) {
  const color = new THREE.Color()

  const ref = useRef()
  const [hovered, setHovered] = useState(false)

  const over = () => setHovered(true)
  const out = () => setHovered(false)

  useEffect(() => {
    if (hovered) document.body.style.cursor = 'pointer'
    return () => (document.body.style.cursor = 'auto')
  }, [hovered])

  useFrame(() => {
    ref.current.material.color.lerp(color.set(hovered ? 'black' : 'white'), 0.2)
    if (hovered) {
      if (ref.current.parent.children[0].name == 'pill') {
        ref.current.parent.children[0].visible = true
        // ref.current.parent.children[0].material.opacity = THREE.MathUtils.lerp(
        //   ref.current.parent.children[0].material.opacity,
        //   hovered ? 1 : 0.01,
        //   0.1
        // )
      }
    } else {
      if (ref.current.userData.index == pageIndex) ref.current.parent.children[0].visible = true
      else if (ref.current.parent.children[0].name == 'pill') ref.current.parent.children[0].visible = false
    }
  })

  return (
    <Text
      ref={ref}
      onPointerOver={over}
      onPointerOut={out}
      onClick={clickCallback}
      font={regular.default}
      {...props}
      children={children}
    />
  )
}
